import { ProviderBuilder, EGenMode } from '@educraft/base';
import { ClockPart } from './generators/clock';

export function registerGenPart(builder: ProviderBuilder): void {
  builder.add(EGenMode.GenPart, ClockPart, 'Part.Clock');
}
